import { Stack, Typography } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Level } from 'theme/enums';

export const ResultCell = ({ data, value, valueFormatted }: ICellRendererParams) => {
  // Group rows have no data and keep the plain (possibly empty) label.
  if (!data) {
    return <>{valueFormatted}</>;
  }

  // getOutcomeLabel returns null for an outcome it does not know, so keep the
  // shared renderer's value-then-placeholder fallback rather than painting an
  // empty cell if the BE ever reports a new one.
  const label = valueFormatted || value || DEFAULT_PLACEHOLDER;

  // The outcome describes the pipeline run, which reports success once staging
  // completes — so a row can read "Success" while nothing reached the quote.
  // Qualify it whenever part rows failed to import.
  if (!data.failedPartCount) {
    return <>{label}</>;
  }

  const imported = data.importedPartCount ?? 0;
  const staged = data.stagedPartCount ?? 0;

  return (
    <Stack sx={{ height: '100%', justifyContent: 'center' }}>
      <Typography level={Level.BODY_SM}>{label}</Typography>
      {/* No Tooltip in here: the column's tooltipValueGetter already covers the
          whole cell and the grid runs tooltipMouseTrack with no delay, so a
          second tooltip would stack on top of it. The ratio explanation rides
          in that one instead. Colours come from the mode-stable tokens for the
          same reason as the manufacturer icon. */}
      <Typography
        level={Level.BODY_XS}
        sx={{ color: imported ? 'custom.warning.main' : 'danger.500' }}
      >
        {t('labelPartsImportedRatio', { imported, staged })}
      </Typography>
    </Stack>
  );
};
